export default {
	unexpectedError: "Unexpected error: {message}",
	createSuccessNotification: "New key result created.",
	createErrorNotification: "Error creating key result: {message}",
	saveSuccessNotification: "Key result saved.",
	saveErrorNotification: "Error saving key result: {message}",
	deleteSuccessNotification: "Key result deleted.",
	deleteErrorNotification: "Error deleting key result: {message}",
	createCommentSuccessNotification: "Comment saved.",
	createCommentErrorNotification: "Error saving comment: {message}",

	externalChangeNotification: "This key result has been updated by someone else. Please refresh the page to see changes.",
};
